import { freddyTheme } from '@coolblue-development/freddy';
export const getHeaderStyles = ({ position }) => ({
    width: '100%',
    height: 'auto',
    minHeight: 'var(--cb-header-height)',
    top: 0,
    zIndex: 'var(--cb-z-index-header)',
    ...(typeof position === 'string' && {
        position,
    }),
    ...(typeof position === 'object' && {
        position: position.xs || 'static',
        ...['xs', 'sm', 'md', 'lg', 'xl'].reduce((styles, breakpoint) => {
            if (!position[breakpoint])
                return styles;
            if (breakpoint === 'xs')
                return styles;
            return {
                ...styles,
                [freddyTheme.breakpoint.minWidth(breakpoint)]: {
                    position: position[breakpoint],
                },
            };
        }, {}),
    }),
});
//# sourceMappingURL=Header.styles.js.map